import { Transition, Variants } from 'framer-motion'

const menuTransition: Transition = {
  type: 'spring',
  damping: 15,
}
export const menuItemLabelAnimationVariants: Variants = {
  init: ({ isSidebarOpen }) => ({
    opacity: isSidebarOpen ? 1 : 0,
    x: isSidebarOpen ? 0 : -15,
    transition: menuTransition,
  }),
  maximize: {
    opacity: 1,
    x: 0,
    transition: menuTransition,
  },
  minimize: {
    opacity: 0,
    x: -15,
    transition: menuTransition,
  },
  exit: {},
}
export const menuItemIconAnimationVariants: Variants = {
  init: ({ isSidebarOpen }) => ({
    marginRight: isSidebarOpen ? '16px' : '0px',
    marginLeft: isSidebarOpen ? '0px' : '4px',
    transition: menuTransition,
  }),
  maximize: {
    marginRight: '16px',
    marginLeft: '0px',
    transition: menuTransition,
  },
  minimize: {
    marginRight: '0px',
    marginLeft: '4px',
    transition: menuTransition,
  },
  exit: {},
}
